require("./payrollLoanRequest.scss");

// @vendor
const React = require("react");
const PropTypes = require("prop-types");
const { withRouter } = require("react-router-dom");
const { FormattedText } = require("core/i18n").i18n;
// @common
const Wizard = require("components/commons/wizard/wizard");
const WizardStep = require("components/commons/wizardStep/wizardStep");
// @components
const ContractLoanTooltip = require("../../../contractLoanTooltip/contractLoanTooltip");
const PayrollLoanCompilationCard = require("../../../contractPayrollLoan/payrollLoanCompilationCard/payrollLoanCompilationCard");
const PayrollLoanRequestStepOne = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestStepOne/payrollLoanRequestStepOne");
const PayrollLoanRequestStepProduct = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestStepProduct/payrollLoanRequestStepProduct");
const PayrollLoanRequestStepTwo = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestStepTwo/payrollLoanRequestStepTwo");
const PayrollLoanRequestNewStepFour = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestNewStepFour/payrollLoanRequestNewStepFour");
const PayrollLoanRequestRejected = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestRejected/payrollLoanRequestRejected");
const PayrollLoanRequestStepThree = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestStepThree/payrollLoanRequestStepThree");
const PayrollLoanRequestError = require("../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestError/payrollLoanRequestError");
const ContractPayrollLoanDocuments = require("../../../contractPayrollLoanDocuments/contractPayrollLoanDocuments");
const ContractLoanSuccess = require("../../../contractLoanSuccess/contractLoanSuccess");
const PayrollLoanLayoutWizard = require("../../../contractPayrollLoan/payrollLoanLayoutWizard/payrollLoanLayoutWizard");
const PayrollLoanContentKOXDTI = require("../../../contractPayrollLoan/payrollLoanLayoutWizard/payrollLoanContentKOXDTI");
const ContractPayrollLoanErrorAsnef = require("../../../contractAsnefError/contractAsnefError");
const { LoadingSection } = require("commonsComponents/loadingSection");
// @core
const { formatText } = require("core/i18n").i18n;
// @helpers
const { getCollectiveByParams } = require("utilities/collectivesHelper");
const { isPrintOfficeMode } = require("utilities/contactCenter/printerHelper");
//@constants
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    MULTICHANNEL_UI_COMPONENT,
} = require("constants/index");
const {
    LOAN_CHECK_CIRBE_PERSONAL,
    PERSONAL_LOAN_DRAGO,
    NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES
} = require("constants/flagBasedFeatures");
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS },
    payrollLoanRecordStatus: { requestStatus, deniedStatus },
    NOT,
    PAYROLL_LOAN_PRE_APPROVED_STATUS: { ASNEF_VALIDATION_ERROR },
} = require("../../../../../loansConstants/index");
const {
    catalogue,
    analyticsId,
} = require("../analytics/payrollLoanRequestAnalytics");

class PayrollLoanRequest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPreLeaveModal: true,
        };

        this.redirect = this.redirect.bind(this);
        this.handleFinishClick = this.handleFinishClick.bind(this);
        this.dropRecord = this.dropRecord.bind(this);
        this.buildLeftContent = this.buildLeftContent.bind(this);
        this.buildContentLayoutWizard =
            this.buildContentLayoutWizard.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    }

    componentDidMount() {
        const {
            immCollectives,
            getCollectiveInfo,
            setCurrentProductCollective,
        } = this.props;
        const immCollectivesInfo = immCollectives.get("collectivesInfo");
        const activeItem = getCollectiveByParams(
            PAYROLL_LOAN_ALIAS,
            null,
            immCollectivesInfo
        );

        getCollectiveInfo(
            [{ alias: PAYROLL_LOAN_ALIAS }],
            MULTICHANNEL_UI_COMPONENT
        );

        if (activeItem) {
            const title = activeItem.get("title") || "";
            setCurrentProductCollective({ title });
        }
    }

    componentDidUpdate(prevProps) {
        const oldStatus =
            prevProps.immPayrollLoanRequest.get("preApprovalState");
        const newStatus =
            this.props.immPayrollLoanRequest.get("preApprovalState");

        if (oldStatus !== newStatus) {
            if (this.getIsDenied()) {
                this.props.history.push("/myprofile/loans-mortgages");
            }
        }
    }

    componentWillUnmount() {
        const { resetStateWizard, resetUploadConfig, resetPrintedIndicators } =
            this.props;
        resetStateWizard();
        resetUploadConfig();

        if (__CONTACT_CENTER__) {
            resetPrintedIndicators();
        }
    }

    handleConfirmLeave() {
        this.setState({
            showPreLeaveModal: false,
        });
    }

    getIsDenied() {
        const { immPayrollLoanRequest } = this.props;
        const initialized = immPayrollLoanRequest.get("initialized");
        const cardDeniedVisible =
            immPayrollLoanRequest.get("cardDeniedVisible");
        const status = immPayrollLoanRequest.get("preApprovalState");
        const isRequest = Object.values(requestStatus).includes(status);
        const isAllowed =
            Object.values(deniedStatus).includes(status) && !cardDeniedVisible;

        return initialized && !(isRequest || isAllowed);
    }

    builDisclaimerText() {
        const { immPayrollLoanRequest } = this.props;

        const initialized = immPayrollLoanRequest.get("initialized");
        const visibleStep = immPayrollLoanRequest.get("visibleStep") - 1;
        let disclaimerText = null;
        let disclaimerCommissionText = null;
        const error = immPayrollLoanRequest.get("error");
        const isRejected = immPayrollLoanRequest.get("rejected");
        const success = immPayrollLoanRequest.get("submitSuccessful");

        if (isRejected || error || success) {
            return null;
        }

        if (visibleStep === FIRST_STEP) {
            disclaimerText = this.buildDisclaimerStepProduct();
        } else if (initialized && visibleStep === SECOND_STEP) {
            disclaimerText = this.buildDisclaimerStepOne();
        }

        if (visibleStep !== FIRST_STEP) {
            disclaimerCommissionText = (
                <div className="payroll-loan-request__disclaimer__product-space payroll-loan-request__disclaimer__commission">
                    <FormattedText value="contractEasyLoanStepOne-contractEasyLoanStepOne_superscriptInfo" />
                </div>
            );
        }

        return (
            <div className="payroll-loan-request__disclaimer">
                {disclaimerText}
                {disclaimerCommissionText}
            </div>
        );
    }

    buildContent() {
        const { immPayrollLoanRequest, immFlagBasedFeatures } = this.props;

        const isRejected = immPayrollLoanRequest.get("rejected");
        const enableDocumentsFlow = immPayrollLoanRequest.get(
            "enableDocumentsFlow"
        );
        const success = immPayrollLoanRequest.get("submitSuccessful");
        const error = immPayrollLoanRequest.get("error");
        const errorCode = immPayrollLoanRequest.get("errorCode");
        const cancelled =
            immPayrollLoanRequest.get("preApprovalState") ===
            requestStatus.CANCELED;
        const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
        const isDenied = this.getIsDenied();
        let taeTooltip;
        let content;

        if (error && errorCode !== ASNEF_VALIDATION_ERROR) {
            content = <PayrollLoanRequestError />;
        } else if (isRejected || cancelled || isDenied) {
            content = <PayrollLoanRequestRejected />;
        } else if (success) {
            taeTooltip = this.buildTaeTooltip();
            content = this.buildSuccess(
                immPayrollLoanRequest,
                taeTooltip,
                isDragoFeature
            );
        } else if (enableDocumentsFlow) {
            const taeTooltip = this.buildTaeTooltip();
            const compilationCard = this.buildSummaryBox(
                taeTooltip,
                false,
                isDragoFeature
            );
            content = this.buildUploadDocumentsFlow(compilationCard);
        } else {
            taeTooltip = this.buildTaeTooltip();
            const wizard = this.buildLeftContent();
            const visibleStep = immPayrollLoanRequest.get("visibleStep") - 1;
            const showTinTooltip = visibleStep === SECOND_STEP;
            const summaryBox = this.buildSummaryBox(
                taeTooltip,
                showTinTooltip,
                isDragoFeature
            );

            content = (
                <div>
                    {wizard}
                    {summaryBox}
                </div>
            );
        }

        return content;
    }

    buildContentLayoutWizard() {
        const {
            immFlagBasedFeatures,
            immPayrollLoanRequest,
            getInstallment,
            setLoanAmountKOxDTI,
            setLoanTermKOxDTI,
            getMinTerm,
            validateAmountKOxDTI,
        } = this.props;

        return (
            <PayrollLoanContentKOXDTI
                immPayrollLoanRequest={immPayrollLoanRequest}
                getMinTerm={getMinTerm}
                getInstallment={getInstallment}
                setLoanAmount={setLoanAmountKOxDTI}
                setLoanTerm={setLoanTermKOxDTI}
                validateAmountKOxDTI={validateAmountKOxDTI}
                isDragoFeature={immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO)}
            />
        );
    }

    buildDisclaimerStepOne() {
        return (
            <div>
                <FormattedText value="payrollLoanRequest-payrollLoanRequest_disclaimerText4" />
            </div>
        );
    }

    buildDisclaimerStepProduct() {
        const { immPayrollLoanRequest } = this.props;
        const isCollective = immPayrollLoanRequest.get("isCollective");
        const disclaimerText = isCollective
            ? "payrollLoanRequest-disclaimerProductCollective2"
            : "payrollLoanRequest-disclaimerProduct2";
        return (
            <div>
                <div>
                    <FormattedText value="payrollLoanRequest-disclaimerProduct1" />
                </div>
                <div className="payroll-loan-request__disclaimer__product-space">
                    <FormattedText
                        className="payroll-loan-request-step-product__disclaimer"
                        value={disclaimerText}
                    />
                </div>
            </div>
        );
    }

    buildLeftContent() {
        const { immPayrollLoanRequest, changeViewPreApprovalKOxDTI } =
            this.props;
        const { showPreLeaveModal } = this.state;
        const isFetchingKOxDTI = immPayrollLoanRequest.get("isFetchingKOxDTI");
        const viewLayoutPreApprovalKOxDTI = immPayrollLoanRequest.get(
            "viewLayoutPreApprovalKOxDTI"
        );
        const preLeaveModalConfig = this.buildPreLeaveModalConfig();
        const combinedShowPreLeaveModal =
            !this.getIsDenied() && showPreLeaveModal;

        if (viewLayoutPreApprovalKOxDTI) {
            if (isFetchingKOxDTI) {
                return (
                    <div className="col-xs-8 ok-section-box">
                        <LoadingSection />
                    </div>
                );
            } else {
                const actions = {
                    handlePrevClick: () =>
                        changeViewPreApprovalKOxDTI(false, WIZARD_SECOND_STEP),
                    handleNextClick: () =>
                        changeViewPreApprovalKOxDTI(false, WIZARD_THIRD_STEP),
                    setWillCancel: this.redirect,
                    cancel: this.redirect,
                };

                const nodataKOxDTI = !immPayrollLoanRequest.getIn([
                    "KOxDTI",
                    "seletedAmountOrTerm",
                ]);
                const cancelButtonText = formatText(
                    "payrollLoanRequest-leaveButton"
                );
                const children = this.buildContentLayoutWizard();

                const initialized = immPayrollLoanRequest.get("initialized");
                const taeTooltip =
                    initialized && !nodataKOxDTI
                        ? this.buildTaeTooltip()
                        : undefined;

                return (
                    <PayrollLoanLayoutWizard
                        taeTooltip={taeTooltip}
                        immPayrollLoan={immPayrollLoanRequest}
                        actions={actions}
                        cancelButtonText={cancelButtonText}
                        cancelButton
                        goBackButton
                        previousButton
                        preleaveModalMessage={preLeaveModalConfig.message}
                        preleaveModalTitle={preLeaveModalConfig.title}
                        preleaveModalLeftButtonConfig={
                            preLeaveModalConfig.leftButtonConfig
                        }
                        preleaveModalRightButtonConfig={
                            preLeaveModalConfig.rightButtonConfig
                        }
                        showPreLeaveModal={combinedShowPreLeaveModal}
                        nodataKOxDTI={nodataKOxDTI}
                        onConfirmLeave={this.handleConfirmLeave}
                    >
                        {children}
                    </PayrollLoanLayoutWizard>
                );
            }
        } else {
            return this.buildWizard(
                this.buildTaeTooltip(),
                preLeaveModalConfig
            );
        }
    }

    buildPreLeaveModalConfig() {
        const { immPayrollLoanRequest } = this.props;
        const initialized = immPayrollLoanRequest.get("initialized");

        let title = formatText("wizard-redirectConfirmationTitle");
        let message = formatText("wizard-redirectConfirmationMessage");

        const leftButtonConfig = {
            text: formatText("wizard-redirectConfirmationAcceptButton"),
            redirect: true,
        };

        const rightButtonConfig = {
            text: formatText("wizard-redirectConfirmationCancelButton"),
        };

        if (initialized) {
            leftButtonConfig.text = formatText(
                "payrollLoanRequest-modalLeaveButton"
            );
            leftButtonConfig.callback = this.dropRecord;

            rightButtonConfig.text = formatText(
                "payrollLoanRequest-continueLater"
            );
            rightButtonConfig.redirect = true;

            title = formatText("payrollLoanRequest-modalLeaveTitle");
            message = formatText("payrollLoanRequest-modalLeaveText");
        }

        return {
            title,
            message,
            leftButtonConfig,
            rightButtonConfig,
        };
    }

    buildStepOne(taeTooltip) {
        const {
            getInstallment,
            getLoansForExpenses,
            getPersonalInformation,
            formHandlers,
            immFlagBasedFeatures,
            immPayrollLoanRequest,
            initialize,
            resetCheckboxCirbe,
            resetMinTermMaxAmount,
            setCirbeCheck,
            setLoanAmount,
            setLoanTerm,
            setPurpose,
            simulationToken,
        } = this.props;

        const stepPreApproval = immPayrollLoanRequest.get(
            "stepCallPreApproval"
        );

        return (
            <PayrollLoanRequestStepOne
                formHandlers={formHandlers}
                getInstallment={getInstallment}
                getLoansForExpenses={getLoansForExpenses}
                getPersonalInformation={getPersonalInformation}
                immContractLoan={immPayrollLoanRequest}
                immFlagBasedFeatures={immFlagBasedFeatures}
                initialize={initialize}
                isDragoFeature={immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO)}
                resetCheckboxCirbe={resetCheckboxCirbe}
                resetMinTermMaxAmount={resetMinTermMaxAmount}
                setCirbeCheck={setCirbeCheck}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                setPurpose={setPurpose}
                stepPreApproval={stepPreApproval}
                simulationToken={simulationToken}
                taeTooltip={taeTooltip}
            />
        );
    }

    buildStepProduct() {
        const { immPayrollLoanRequest, downloadPreContractDocument } =
            this.props;

        return (
            <PayrollLoanRequestStepProduct
                immPayrollLoanRequest={immPayrollLoanRequest}
                downloadPreContractDocument={downloadPreContractDocument}
                footerLinkCentered
            />
        );
    }

    // Builders
    buildStepThree(isDragoFeature) {
        const {
            immPayrollLoanRequest,
            loadFileInUpload,
            clearErrorsFile,
            removeUploadedFile,
            resetUploadConfig,
            handlerEditFileName,
            loadFilesPersonalLoan,
            immFlagBasedFeatures,
            immPrinter
        } = this.props;
        const status = immPayrollLoanRequest.get("preApprovalState");

        return (
            <PayrollLoanRequestStepThree
                clearErrorsFile={clearErrorsFile}
                removeUploadedFile={removeUploadedFile}
                loadFileInUpload={loadFileInUpload}
                immPayrollLoanRequest={immPayrollLoanRequest}
                recordStatus={status}
                resetUploadConfig={resetUploadConfig}
                handlerEditFileName={handlerEditFileName}
                loadFilesPersonalLoan={loadFilesPersonalLoan}
                isDragoFeature={isDragoFeature}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immPrinter={immPrinter}
            />
        );
    }

    buildStepTwo(isDragoFeature) {
        const { formHandlers, immPayrollLoanRequest, immFlagBasedFeatures, } =
            this.props;

        return (
            <PayrollLoanRequestStepTwo
                onActionApprovalLetter={formHandlers.handleActionApprovalLetter}
                onDownloadINE={formHandlers.handleDownloadINE}
                immPayrollLoanRequest={immPayrollLoanRequest}
                immFlagBasedFeatures={immFlagBasedFeatures}
                isDragoFeature={isDragoFeature}
            />
        );
    }
    buildNewStepFour(isDragoFeature) {
        const { immPayrollLoanRequest, checkRadioButtonOffice, printDocumentOffice, checkReadDocument, checkCheckedDocument, immProfile, preContractualMail, requestProfile, sendMail, sendEasyLoanSimpleEmail } = this.props;

        return (
            <PayrollLoanRequestNewStepFour
                immPayrollLoanRequest={immPayrollLoanRequest}
                isDragoFeature={isDragoFeature}
                checkReadDocument={checkReadDocument}
                checkCheckedDocument={checkCheckedDocument}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                sendMail={sendMail}
                sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                checkRadioButtonOffice={checkRadioButtonOffice}
                printDocumentOffice={printDocumentOffice}
            />
        );
    }
    buildSuccess(immPayrollLoanRequest, taeTooltip, isDragoFeature) {
        return (
            <section className="contract-payroll-loan-success">
                <ContractLoanSuccess
                    immData={immPayrollLoanRequest}
                    taeTooltip={taeTooltip}
                    isDragoFeature={isDragoFeature}
                    viewToRender={"contract-payroll-request"}
                />
            </section>
        );
    }

    buildSummaryBox(taeTooltipElement, showTinTooltip, isDragoFeature) {
        const { immPayrollLoanRequest, setCurrentProductCollective, isPayrrolLoan } =
            this.props;
        const isCollective = immPayrollLoanRequest.get("isCollective");

        let nodataKOxDTI = undefined;
        let callKOxDTI = undefined;
        let taeTooltip = undefined;

        if (immPayrollLoanRequest.get("viewLayoutPreApprovalKOxDTI")) {
            nodataKOxDTI = !immPayrollLoanRequest.getIn([
                "KOxDTI",
                "seletedAmountOrTerm",
            ]);
            callKOxDTI = true;
        }

        const initialized = immPayrollLoanRequest.get("initialized");

        if (initialized && !nodataKOxDTI) {
            taeTooltip = taeTooltipElement;
        }

        return (
            <div className="col-xs-4">
                <PayrollLoanCompilationCard
                    isRequest
                    immStep={immPayrollLoanRequest}
                    isDragoFeature={isDragoFeature}
                    taeTooltip={taeTooltip}
                    setCurrentProductCollective={setCurrentProductCollective}
                    showTinTooltip={showTinTooltip}
                    nodataKOxDTI={nodataKOxDTI}
                    callKOxDTI={callKOxDTI}
                    isCollective={isCollective}
                    isPayrrolLoan={isPayrrolLoan}
                />
            </div>
        );
    }

    buildTaeTooltip() {
        const { immPayrollLoanRequest } = this.props;

        return (
            <ContractLoanTooltip
                immContractLoan={immPayrollLoanRequest}
                clarifyingText="clarifyingText"
            />
        );
    }

    buildUploadDocumentsFlow(compilationCard) {
        const {
            finishBtnUploadDocumentsFlow,
            getLoansForExpenses,
            immPayrollLoanRequest,
            initialize,
            loadFileInUpload,
            removeUploadedFile,
            clearErrorsFile,
            handlerEditFileName,
            simulationToken,
        } = this.props;
        const status = immPayrollLoanRequest.get("preApprovalState");
        const initialized = immPayrollLoanRequest.get("initialized");
        const isFetchingLoans = immPayrollLoanRequest.get("isFetchingLoans");

        return (
            <ContractPayrollLoanDocuments
                dropRecord={this.dropRecord}
                compilationCard={compilationCard}
                initialize={initialize}
                initialized={initialized}
                isFetchingLoans={isFetchingLoans}
                getLoansForExpenses={getLoansForExpenses}
                finishBtn={finishBtnUploadDocumentsFlow}
                loadFileInUpload={loadFileInUpload}
                clearErrorsFile={clearErrorsFile}
                removeUploadedFile={removeUploadedFile}
                immPayrollLoanRequest={immPayrollLoanRequest}
                recordStatus={status}
                simulationToken={simulationToken}
                handlerEditFileName={handlerEditFileName}
                onConfirmLeave={this.handleConfirmLeave}
            />
        );
    }

    isFinalButtonDisabled() {
        const {
            immPrinter,
            immFlagBasedFeatures

        } = this.props;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);

        const documentPrinterAndConfirm = immPrinter.get('documentsPrintedAndSigned')
        const isDocumentPrinterAndConfirmNoOrEmpty = documentPrinterAndConfirm === NOT || documentPrinterAndConfirm === '';
        if (!newPayrollLoanFF && __CONTACT_CENTER__ && isPrintOfficeMode() && isDocumentPrinterAndConfirmNoOrEmpty) {
            return true

        } else {
            return false
        }
    }

    buildWizard(taeTooltip, preleaveModalConfig) {
        const {
            immFlagBasedFeatures,
            immPayrollLoanRequest,
            getAsnefValidation,
            resetStep,
            setVisibleStep,
            validateStep,

        } = this.props;

        const disclaimerText = this.builDisclaimerText();
        const payrolLoanRequestPrintedDocument = immPayrollLoanRequest.get('payrollLoanRequestPrintedDocument');
        const processType = immPayrollLoanRequest.get("processType");
        const immUpload = immPayrollLoanRequest.get("upload");
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
        let immSteps = newPayrollLoanFF ? immPayrollLoanRequest.get("newSteps") : immPayrollLoanRequest.get("steps");
        const visibleStep = immPayrollLoanRequest.get("visibleStep");
        const documents = immPayrollLoanRequest.get('filePayrollLoanINEDocument');
        const agreeIneCheckbox = immPayrollLoanRequest.get("agreeIneCheckbox");
        const isCallingSaveInProgress = immPayrollLoanRequest.get(
            "isCallingSaveInProgress"
        );
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const isFetchingStepThree =
            immUpload.get("isFetching") ||
            immUpload.get("isFetchingDocumentsConfirm") ||
            immUpload.get("isLoadingFiles");
        const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
        const stepsLenght = immSteps.size;
        const stepProduct = this.buildStepProduct(taeTooltip);
        const stepOneComponent = this.buildStepOne(taeTooltip);
        const stepTwoComponent = this.buildStepTwo(isDragoFeature);
        const newStepFourComponent = this.buildNewStepFour(isDragoFeature);
        const stepThreeComponent = this.buildStepThree(isDragoFeature);
        const nextButtonStepOneDisabled =
            immFlagBasedFeatures.get(LOAN_CHECK_CIRBE_PERSONAL) &&
            !immPayrollLoanRequest.get("checkboxCirbe");
        const cancelButtonText = formatText("payrollLoanRequest-leaveButton");
        const simulationButtonText = formatText("payrollLoanPrecontractual-simulationButton");
        const cancelStepProduct = immPayrollLoanRequest.get("initialized")
            ? cancelButtonText
            : formatText("common-cancel");

        const finalButton = __CONTACT_CENTER__
            ? "payrollLoanRequestStepThree-finishButton"
            : "payrollLoanRequestStepThree-ctaButton";

        const actions = {
            validateStep: validateStep,
            setVisibleStep: setVisibleStep,
            setWillCancel: this.redirect,
            cancel: this.redirect,
            finish: this.handleFinishClick,
            resetStep,
        };

        const tealiumData = [
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_1_VIEW](processType),
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_2_VIEW](processType),
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_3_VIEW](processType),
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_4_VIEW](processType),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_1_SUCCESS](processType),
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_2_SUCCESS](processType),
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_STEP_3_SUCCESS](processType),
        ];
        const finalButtonDisabled = this.isFinalButtonDisabled();
        const commonSteps = [
            <WizardStep
                nextButton
                position="first"
                nextButtonCustomText={simulationButtonText}
                isButtonsCentered
                hideNextIcon
            >
                {stepProduct}
            </WizardStep>,
            <WizardStep
                nextButton
                position="middle"
                cancelButtonText={cancelButtonText}
                cancelButton
                isLoading={isCallingSaveInProgress}
                nextButtonDisabled={nextButtonStepOneDisabled}
            >
                {stepOneComponent}
            </WizardStep>,
            <WizardStep
                position="middle"
                cancelButtonText={cancelButtonText}
                cancelButton
                isLoading={immPayrollLoanRequest.get("isFetching")}
                getAsnefValidation={getAsnefValidation}

            >
                {stepTwoComponent}
            </WizardStep>,
            <WizardStep
                position="last"
                immFinalButton={finalButton}
                cancelButtonText={cancelButtonText}
                finalButtonModifier="secondary"
                isLoading={isFetchingStepThree}
                cancelButton
                ccDefaultBehaviour
                omitPreviousButton
                omitPreviousButtonWP
                finalButtonDisabled={finalButtonDisabled}

            >
                {stepThreeComponent}
            </WizardStep>
        ];

        const newSteps = newPayrollLoanFF ? [
            ...commonSteps.slice(0, 3),
            <WizardStep
                position="middle"
                cancelButtonText={cancelButtonText}
                cancelButton
                isLoading={!documents}
                nextButtonDisabled={!agreeIneCheckbox || (isPrintOfficeMode() && !payrolLoanRequestPrintedDocument)}
                omitPreviousButton
                omitPreviousButtonWP
            >
                {newStepFourComponent}
            </WizardStep>,
            ...commonSteps.slice(3)
        ] : commonSteps;

        return (
            <div className="col-xs-8">
                <Wizard
                    immSteps={immSteps}
                    stepsAmount={stepsLenght}
                    visibleStep={visibleStep}
                    actions={actions}
                    getAsnefValidation={getAsnefValidation}
                    preleaveModalMessage={preleaveModalConfig.message}
                    preleaveModalTitle={preleaveModalConfig.title}
                    preleaveModalLeftButtonConfig={
                        preleaveModalConfig.leftButtonConfig
                    }
                    preleaveModalRightButtonConfig={
                        preleaveModalConfig.rightButtonConfig
                    }
                    showPreLeaveModal={this.state.showPreLeaveModal}
                    onConfirmLeave={this.handleConfirmLeave}
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={{
                        next: { ...tealiumEvents[visibleStep - 1], data: true },
                    }}
                    isTaggingSecondVersion
                >
                    {newSteps}
                </Wizard>
                {disclaimerText}
            </div>
        );
    }

    dropRecord(callback) {
        const { immPayrollLoanRequest } = this.props;
        const recordId = immPayrollLoanRequest.get("recordId");
        this.props.cancelLoanRecord(recordId, callback);
    }

    handleFinishClick() {
        // For Privada all the actual saving logic is in the validateStep action
        // but in Contact Center we redirect to the loans/mortgages landing without saving to continue the operative later from the Web
        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            this.setState(
                {
                    showPreLeaveModal: false,
                },
                () => {
                    // IMPORTANT: The router redirection needs to be called in the callback after setState
                    // otherwise is not executed after the re-render caused by the state change
                    this.props.history.push("/myprofile/loans-mortgages");
                }
            );
        }
    }

    redirect() {
        this.props.history.push("/myprofile/loans-mortgages");
    }

    render() {
        const { immPayrollLoanRequest } = this.props;
        const errorAsnef = immPayrollLoanRequest.get("errorAsnef");
        const errorCode = immPayrollLoanRequest.get("errorCode");
        const error = immPayrollLoanRequest.get("error");
        const asnefValidationError = error && errorCode === ASNEF_VALIDATION_ERROR;
        let content;
        if (errorAsnef || asnefValidationError) {
            content = (
                <ContractPayrollLoanErrorAsnef
                    errorValue={immPayrollLoanRequest.get("totalAmount")}
                    history={this.props.history}
                />
            );
        } else {
            content = this.buildContent();
        }
        return (
            <div>
                <div className="payroll-loan-request row">
                    <div className="row">
                        <div
                            className="row payroll-loan-request__content-container"
                            id="printable-wizard"
                        >
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PayrollLoanRequest.propTypes = {
    cancelLoanRecord: PropTypes.func.isRequired,
    changeViewPreApprovalKOxDTI: PropTypes.func,
    clearErrorsFile: PropTypes.func.isRequired,
    finishBtnUploadDocumentsFlow: PropTypes.func.isRequired,
    formHandlers: PropTypes.object.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getLoansForExpenses: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getPersonalInformation: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    handlerEditFileName: PropTypes.func.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    immPayrollLoan: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    loadFilesPersonalLoan: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    resetCheckboxCirbe: PropTypes.func.isRequired,
    setCirbeCheck: PropTypes.func.isRequired,
    requestLoanApproval: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    resetMinTermMaxAmount: PropTypes.func.isRequired,
    resetStateWizard: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    setCurrentProductCollective: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanAmountKOxDTI: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setLoanTermKOxDTI: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    simulationToken: PropTypes.string,
    validateAmountKOxDTI: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    isPayrrolLoan: PropTypes.bool.isRequired,
};

module.exports = withRouter(PayrollLoanRequest);
